<div class="modal-content">

    <div class="modal-body">
        <button type="button" class="close" aria-label="Close" (click)="onCancel()">
            <span aria-hidden="true">&times;</span>
        </button>  
        <div id="myVimeoVideo"  style="text-align: center;"></div> 
        <!--div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/809451939?h=9a55f3462d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Chords2Cure Come Together Concert 2023"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script-->
    </div>
</div> 